
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Initial Consultation',
      description: 'We begin with a comprehensive discovery session to understand your business challenges, objectives, market position, and specific requirements for strategic consulting services.',
      icon: 'ri-chat-4-line'
    },
    {
      number: '02',
      title: 'Strategic Analysis',
      description: 'Our expert team conducts in-depth analysis of your business operations, market dynamics, competitive landscape, and internal capabilities to identify opportunities and challenges.',
      icon: 'ri-search-line'
    },
    {
      number: '03',
      title: 'Solution Design',
      description: 'We develop customized strategies and actionable recommendations tailored to your unique business context, incorporating industry best practices and innovative approaches.',
      icon: 'ri-pencil-ruler-2-line'
    },
    {
      number: '04',
      title: 'Implementation Support',
      description: 'Our consultants work alongside your team to execute the strategic plan, providing hands-on guidance, training, and ongoing support throughout the implementation process.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '05',
      title: 'Performance Monitoring',
      description: 'We establish key performance indicators and monitoring systems to track progress, measure results, and ensure the implemented solutions deliver expected business outcomes.',
      icon: 'ri-line-chart-line'
    },
    {
      number: '06',
      title: 'Continuous Optimization',
      description: 'Through regular reviews and performance assessments, we refine strategies and make necessary adjustments to maximize long-term value and sustained competitive advantage.',
      icon: 'ri-refresh-line'
    }
  ];

  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Consulting Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A proven methodology that ensures successful outcomes through systematic analysis, strategic planning, and expert execution
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-blue-100"
            >
              <div className="absolute -top-4 -left-4 w-16 h-16 bg-blue-600 text-white rounded-xl flex items-center justify-center font-bold text-xl shadow-lg">
                {step.number}
              </div>
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-5 ml-auto shadow-sm">
                <i className={`${step.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
